import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { fundsSlice } from '!views/Market';
import { marketStockExchangeSlice } from '!views/Market/StockExchange/_marketStockExchange.slice';
import { ButtonMinus, ButtonPlus } from '»components/atoms/Buttons';
import {
  useCurrentPage,
  useIsTitleNegotiable,
  useNegModalContext,
} from '»utils/customHooks';

import { WrapperButtons } from './TrlCardNegButtons.styles';

export const TrlCardNegButtons = ({
  isCardMobileList,
  canTrade,
  symbol,
  exchange,
  securityType,
}) => {
  const dispatch = useDispatch();

  const { isMarketStockExchangePage, isFunds } = useCurrentPage();

  const { openInsertOrderModal } = useNegModalContext();

  const isTitleNegotiable = useIsTitleNegotiable({
    isMarketPrimaryScreen: false,
    isFundsPrimaryScreen: false,
    canTrade,
  });

  return (
    <WrapperButtons isCardMobileList={isCardMobileList}>
      <ButtonMinus
        disabled={!isTitleNegotiable}
        isCard
        onClick={(e) => {
          if (isCardMobileList && isMarketStockExchangePage) {
            e.stopPropagation();
            dispatch(
              marketStockExchangeSlice.actions.setSelectedTitle({
                symbol,
                exchange,
                securityType,
              }),
            );
          } else if (isCardMobileList && !isMarketStockExchangePage) {
            e.stopPropagation();
            dispatch(
              fundsSlice.actions.setSelectedFundsManagerTitle({
                symbol,
                securityExchange: exchange,
                securityType,
              }),
            );
          }
          openInsertOrderModal(isFunds ? 'E' : 2);
        }}
      />
      <ButtonPlus
        disabled={!isTitleNegotiable}
        isCard
        onClick={(e) => {
          if (isCardMobileList && isMarketStockExchangePage) {
            e.stopPropagation();
            dispatch(
              marketStockExchangeSlice.actions.setSelectedTitle({
                symbol,
                exchange,
                securityType,
              }),
            );
          } else if (isCardMobileList && !isMarketStockExchangePage) {
            e.stopPropagation();
            dispatch(
              fundsSlice.actions.setSelectedFundsManagerTitle({
                symbol,
                securityExchange: exchange,
                securityType,
              }),
            );
          }
          openInsertOrderModal(isFunds ? 'D' : 1);
        }}
      />
    </WrapperButtons>
  );
};

TrlCardNegButtons.propTypes = {
  isCardMobileList: PropTypes.bool,
  canTrade: PropTypes.string,
  symbol: PropTypes.string,
  exchange: PropTypes.string,
  securityType: PropTypes.string,
};
